var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"warning-message mb-8 mx-8 tw-shadow-2xl",staticStyle:{"margin":"-20px 0 0 0","border":"1px solid var(--grey-900)"}},[_c('div',{staticStyle:{"font-size":"24px","font-weight":"bold","margin":"0 0 15px 0"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }